package io.horion.cv.components.shared

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun DashboardCardBlock(
    minHeight: CSSLengthOrPercentageNumericValue = 140.px,
    content: @Composable () -> Unit
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .minHeight(minHeight)
            .backgroundColor(Colors.White)
            .borderRadius(8.px)
            .border(1.px, LineStyle.Solid, Colors.lineBorder)
            .padding(topBottom = 24.px, leftRight = 20.px),
        contentAlignment = Alignment.Center
    ) {
        content()
    }
}